import {Grid} from '@material-ui/core';
// import MaterialTable from "material-table";
import React from 'react';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tableIcons} from '../../../../../components/TableIcons';
import {getFields} from './RecordFormatFieldSearchTable';

const columns = [
  {
    title: 'Temp Variable',
    field: 'tempVariable',
  },
];

const TempVariablesTable = ({tempVariablesTableData, setSelectedRows, selectedRows}) => {
  return (
    <>
      <Grid item xs={12} className="">
        <div className="custom-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={tempVariablesTableData}
            textAlign="left"
            options={{
              toolbar: false,
              search: false,
              selection: true,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            onSelectionChange={(rows, unSelected) => {
              if (unSelected?.tableData?.checked) {
                setSelectedRows([
                  ...selectedRows,
                  {
                    ...unSelected,
                    fieldCode: unSelected.tempVariable,
                    ...getFields({fieldCode: 'TMP' + unSelected.tempVariable}),
                    tableData: {...unSelected.tableData, id: unSelected.tempVariable},
                    fieldType: 'Temp Variables',
                  },
                ]);
              } else {
                const updatedRows = [...selectedRows]
                  .filter((ele) => ele.fieldCode !== unSelected.tempVariable)
                  .map((ele) => {
                    return {...ele, tableData: {...ele.tableData, id: ele.tempVariable}};
                  });
                setSelectedRows(updatedRows);
              }
            }}
          />
        </div>
      </Grid>
    </>
  );
};

export default TempVariablesTable;
